import { Component, Input, OnInit } from '@angular/core';
import { Attending } from "../../../model/attending";
import { AttendingService } from "../../../service/attending.service"
import { InstallationPeriod } from "../../../constants/installation-period";
import { AttendingStatus } from "../../../constants/attending-status";
import { ToastService } from "../../../../shared/service/toast.service"
import { MonitoringStepStatus } from "../../../constants/monitoring-step-status";
import { EquipmentService } from "../../../../shared/service/equipment.service"
import { Equipment } from "../../../../shared/model/equipment";
import { SimCardService } from "../../../../shared/service/sim-card.service"
import { SimCard } from '../../../../shared/model/sim-card';
import { AttendingType } from '../../../constants/attending-type';


@Component({
  selector: 'tx-monitoring-pre-evaluation',
  templateUrl: './monitoring-pre-evaluation.component.html',
  styleUrls: ['./monitoring-pre-evaluation.component.css']
})


export class MonitoringPreEvaluationComponent implements OnInit {

  _attending: Attending;
  _modelFiles: Array<any>;
  _viewMode: boolean;
  files: Array<any>;
  vehicleParts: Map<string, string>;
  equipments: Array<Equipment> = new Array();
  equipmentSelected: Equipment;
  simCardSelected: SimCard;
  simCards: Array<SimCard> = new Array();
  equipmentAttributesTree = ['serial'];
  simCardAttributesTree = ['iccid'];
  changeEquipmentInfo: boolean;
  typedIccId: string;
  typedSerial: string;

  EQUIPMENT_STATUS_NAME_IN_ATTENDING = 'EM_ATENDIMENTO'

  constructor(private _attendingService: AttendingService,
    private _toastService: ToastService,
    private _equipmentService: EquipmentService,
    private _simCardService: SimCardService) {
    this.setUpObservers();
  }

  ngOnInit() {
    this.setupEmptyEntities();
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this.handle();
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set viewMode(viewMode) {
    this._viewMode = viewMode;
  }

  get viewMode() {
    return this._viewMode;
  }

  @Input()
  set modelFiles(modelFiles) {
    this._modelFiles = modelFiles;
  }

  get modelFiles() {
    return this._modelFiles;
  }

  markAsAccepted(file) {
    file.accepted = file.accepted ? !file.accepted : true;
    this._attendingService.acceptInfoFile(file.id, file.accepted, this._attending.id).subscribe(
      response => file = response,
      error => this.showMessage(error.text)
    );
  }

  handleRejection(file) {
    file.accepted = false;
    this.removeFileFromMemoryList(file);
    this.deleteInfoFile(file);
    this.createUnsentParts(this.files);
  }

  canContinue() {

    if (this.vehicleParts) {
      let filesToBeAccepted = this.getFilesToBeAcceptedSize();
      let filesAccepted = this.getAcceptedFilesSize();
      return filesAccepted >= filesToBeAccepted;
    }
    return false;
  }

  submit() {
    let allFilesReachedBackEnd = this._attendingService.getCanContinueMonitoringWorkFlow(this.attending.id, InstallationPeriod.PRE_INSTALLATION)
    if (allFilesReachedBackEnd) {
      this._attendingService.updateStatus(this._attending.id, AttendingStatus.STARTED).subscribe(
        response => {
          this.showMessage('Monitoramento atualizado!');
          this._attending.monitoring.preEvaluationStep = MonitoringStepStatus.FINISHED;
          this._attending.monitoring.validationStep = MonitoringStepStatus.CURRENT;
        },
        error => this.showMessage(error.text)
      );
    } else {
      this.showMessage("Ocorreu um erro durante a confirmação de um dos arquivos, por favor atualize a página!");
    }
  }

  private handle() {
    this._attendingService
      .getVehicleParts(this._attending.id, InstallationPeriod.PRE_INSTALLATION)
      .subscribe(
        response => {
          this.vehicleParts = response;
          this.handleFiles();
        },
        error => this.showMessage(error.text)
      );
  }

  private handleFiles() {
    this.files = new Array();
    if (this.attending.attendingInfo.files && this.attending.attendingInfo.files.length > 0) {
      this.handleExistingFiles();
    } else {
      this.simpleCreateEmptyFiles(this.vehicleParts);
    }
  }

  private handleExistingFiles() {
    this.setFiles();
    this.createUnsentParts(this._attending.attendingInfo.files);
  }

  private createUnsentParts(files) {
    let unsentParts = this.getUnsentVehicleParts(files);
    if (unsentParts.length > 0) {
      this.createEmptyFiles(this.vehicleParts, unsentParts);
    }
  }

  private getUnsentVehicleParts(files) {
    let partsToCreate = new Array();
    for (let key in this.vehicleParts) {
      let mustCreate = true;
      files.forEach((value) => {
        if (value.vehiclePart === key) {
          mustCreate = false;
        }
      });
      if (mustCreate) {
        partsToCreate.push(key);
      }
    }
    return partsToCreate;
  }

  private setFiles() {
    this.attending.attendingInfo.files.forEach((value) => {
      if (value.period === InstallationPeriod.PRE_INSTALLATION) {
        this.files.push(value);
      }
    });
  }

  private createEmptyFiles(vehicleParts, keysToCreate) {
    for (let key in vehicleParts) {
      if (keysToCreate.includes(key)) {
        this.files.push({
          description: vehicleParts[key],
          vehiclePart: key,
          accepted: false,
          period: InstallationPeriod.PRE_INSTALLATION
        });
      }
    }
  }

  private simpleCreateEmptyFiles(vehicleParts) {
    for (let key in vehicleParts) {
      this.files.push({
        description: vehicleParts[key],
        vehiclePart: key,
        accepted: false,
        period: InstallationPeriod.PRE_INSTALLATION
      });
    }
  }

  private getAcceptedFilesSize() {
    let size = 0;
    this.files.forEach((value) => {
      if (value.accepted) {
        size = size + 1;
      }
    });
    return size;
  }

  private getFilesToBeAcceptedSize() {
    let size = 0;
    for (let key in this.vehicleParts) {
      size = 1 + size;
    }
    return size;
  }

  private removeFileFromMemoryList(file) {
    let fileIndex = this.files.indexOf(file);
    this.files.splice(fileIndex, 1);
  }

  private deleteInfoFile(file) {
    this._attendingService.deleteInfoFile(file.id, this._attending.id).subscribe(
      response => {
        this.showMessage('Arquivo removido com sucesso!')
      },
      error => this.showMessage(error.text)
    );
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 40000);
  }

  updateEquipment() {
    let updateEquipmentInfo = {
      'equipmentStatusName': this.EQUIPMENT_STATUS_NAME_IN_ATTENDING,
      'equipment': this.equipmentSelected,
      'simCard': this.simCardSelected
    }

    this._attendingService.updateEquipmentInfo(this._attending.id, updateEquipmentInfo).subscribe(
      response =>
        this.showMessage('Equipamento atualizado com sucesso!'),
      error => this.showMessage(error.text)
    );
  }

  setUpObservers() {

    this._equipmentService.find$
      .subscribe(equipments => this.equipments = equipments);

    this._simCardService.find$
      .subscribe(simCards => this.simCards = simCards);
  }

  findBySerial(serial) {
    this.typedSerial = serial;
    this._equipmentService.findBySerial(serial);
  }

  private setupEmptyEntities() {
    this.changeEquipmentInfo = false;
    this.typedSerial = this.getCurrentEquipmentSerial();
    this.typedIccId = this.getCurrentSimCardIccId();
  }

  private setChangeEquipmentInfo() {
    this.changeEquipmentInfo = !this.changeEquipmentInfo;
  }

  findByIccid(iccid) {
    this.typedIccId = iccid;
    this._simCardService.findAvailableSimCardsWithAccessByIccidContains(iccid);
  }

  canUpdate() {
    let validateSerial = this.equipmentSelected != null && this.typedSerial == this.equipmentSelected.serial;
    let validateSimCard = this.simCardSelected != null && this.typedIccId == this.simCardSelected.iccid
    return validateSerial && validateSimCard;
  }

  getCurrentEquipment() {
    return this._attending.attendingEquipmentInfo.equipmentChosenForAttending;
  }

  getCurrentEquipmentSerial() {
    if (this.getCurrentEquipment() != null) {
      return this.getCurrentEquipment().serial;
    } else {
      return '';
    }
  }

  getCurrentSimCard() {
    if (this._attending.attendingEquipmentInfo.equipmentChosenForAttending &&
      this._attending.attendingEquipmentInfo.equipmentChosenForAttending.simCard != null) {
      return this._attending.attendingEquipmentInfo.equipmentChosenForAttending.simCard;
    } else {
      return null;
    }
  }

  getCurrentSimCardIccId() {
    if (this.getCurrentSimCard() != null) {
      return this.getCurrentSimCard().iccid;
    } else {
      return '';
    }
  }

  setEquipmentSelected(equipment) {
    this.equipmentSelected = equipment;
    if (this.equipmentSelected.simCard != null) {
      this.typedIccId = this.equipmentSelected.simCard.iccid;
      this.simCardSelected = this.equipmentSelected.simCard;
    } else {
      this.simCardSelected = this.getCurrentSimCard();
    }
  }

  setSimCardSelected(simCard) {
    this.simCardSelected = simCard;
    if (this.equipmentSelected == null) {
      this.equipmentSelected = this.getCurrentEquipment();
    }
  }

  attendingTypeIsAudit() {
    return this.attending.type == AttendingType.AUDIT
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/monitoring-pre-evaluation/monitoring-pre-evaluation.component.ts